export default __webpack_public_path__ + "static/media/motorcycle.57f3731f.svg";